<template>
  <span :class="['nuxt-icon', { 'nuxt-icon--fill': !filled }]">
    <Icon
      :name="`app:${name}`"
      mode="svg"
    />
  </span>
</template>

<script lang="ts" setup>
defineProps<{
  name: string;
  filled?: boolean;
}>();
</script>

<style scoped>
  .nuxt-icon--fill :deep(svg *) {
    fill: currentColor;
  }
</style>
